<template>
  <vue-final-modal
    :name="nameModal"
    overlay-class="modal-overlay"
    classes="modal-container"
    :click-to-close="clickToClose"
    :content-class="`modal-content ${contentClass}`"
    :esc-to-close="escToClose"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </vue-final-modal>
</template>

<script>
export default {
  name: 'AppDialog',
  props: {
    nameModal: {
      type: String,
      default: 'test'
    },
    clickToClose: {
      type: Boolean,
      default: true
    },
    escToClose: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  max-width: 428px;

  @media (max-width: 579px) {
    max-height: 100dvh;
    max-width: 100%;
    height: 100dvh;
    width: 100%;
  }
}

::v-deep .modal-content.fullscreen {
  max-height: 100dvh;
  max-width: 100%;
  height: 100dvh;
  width: 100%;
}

::v-deep .modal-overlay {
  background-color: rgba(33, 33, 33, 0.46);
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
